import {ACTION} from './constants';
import request from '../../../../utils/request';
import {requestConfig} from "../../../../config/apiResource";
import {showMainLoader, hideMainLoader} from '../../../actions';

export function getInformationDetailContent(serverData,informationId) {
    if(serverData.url){
        let urlArray=serverData.url.split('/');
        informationId = urlArray[urlArray.length-1];
    }

    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getInformationDetailContent(informationId))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.GET_INFORMATION_DETAIL_CONTENT , data: json.data });
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Information data: " + error)
            });
    }
}


export function verifyDistributor(formData) {
    return dispatch => {
        return request(requestConfig.verifyDistributor(formData))
            .then((json) => {
                json && dispatch({ type: ACTION.VERIFY_DISTRIBUTOR , data: json.data });
                return json
            }).catch((error) => {
                console.log("Got Error with send otp: " + error)
            });
    }
}

export function clearInformationDetail() {
    return {type:ACTION.CLEAR_INFORMATION_DETAIL_CONTENT}
}
